/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface LeadListPatch
 */
export interface LeadListPatch {
  /**
   *
   * @type {Array<any>}
   * @memberof LeadListPatch
   */
  audienceIds?: Array<any>;
  /**
   *
   * @type {Array<any>}
   * @memberof LeadListPatch
   */
  csvIds?: Array<any>;
  /**
   *
   * @type {string}
   * @memberof LeadListPatch
   */
  name?: string;
}

/**
 * Check if a given object implements the LeadListPatch interface.
 */
export function instanceOfLeadListPatch(value: object): value is LeadListPatch {
  return true;
}

export function LeadListPatchFromJSON(json: any): LeadListPatch {
  return LeadListPatchFromJSONTyped(json, false);
}

export function LeadListPatchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LeadListPatch {
  if (json == null) {
    return json;
  }
  return {
    audienceIds:
      json['audience_ids'] == null ? undefined : json['audience_ids'],
    csvIds: json['csv_ids'] == null ? undefined : json['csv_ids'],
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function LeadListPatchToJSON(value?: LeadListPatch | null): any {
  if (value == null) {
    return value;
  }
  return {
    audience_ids: value['audienceIds'],
    csv_ids: value['csvIds'],
    name: value['name'],
  };
}
